module.exports = __webpack_public_path__ + "static/media/template-info.11b42601.png";